<div class="modal-header">
    <h2 class="mat-dialog-title" mat-dialog-title>
        <span *ngIf="localization.model.id" trans>Update Localization</span>
        <span *ngIf="!localization.model.id" trans>Create New Localization</span>
    </h2>
    <button type="button" (click)="close()" class="close-button no-style icon-button">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<form class="modal-content" (ngSubmit)="confirm()" ngNativeValidate>
    <div class="mat-dialog-content" mat-dialog-content>
        <div class="input-container">
            <label for="localization-name" trans>Localization Name</label>
            <input type="text" [(ngModel)]="localization.model.name" name="localization-name" id="localization-name" required>
            <div class="error" *ngIf="errors.name">{{errors.name}}</div>
        </div>
    </div>

    <div class="buttons right mat-dialog-actions" mat-dialog-actions>
        <button (click)="close()" mat-button type="button" class="button cancel" trans>Cancel</button>
        <button type="submit" mat-raised-button color="accent" class="button primary submit-button" trans>
            <span *ngIf="localization.model.id" trans>Update</span>
            <span *ngIf="!localization.model.id" trans>Create</span>
        </button>
    </div>
</form>

<loading-indicator [isVisible]="loading" class="overlay"></loading-indicator>